import React, { Component } from 'react';
import './App.css';
import './Icons.css';
import CustomerLogin from './CustomerLogin';
import Login from './Login';
import App from './App';
import SSORedirectURL from './SSORedirectURL';

import {
    BrowserRouter as Router,
    Route, Switch, Redirect
} from 'react-router-dom';


class Main extends Component {
    constructor(props){
        super(props);
        this.state = {
            authorized: false,
            token: null,
            tokenExpiration: undefined,
            isAdmin: false,
            businessName: null,
            vRadiusServerId:null
        };

        this.showApp = this.showApp.bind(this);
        this.setUnauthorized = this.setUnauthorized.bind(this);
        this.setAdmin = this.setAdmin.bind(this);
        this.setBusinessName = this.setBusinessName.bind(this);
        this.setVradiusServerId = this.setVradiusServerId.bind(this);
        // When accessing to path "/" is going directly to APP without going through Login or SSORedirectURL
        // We need to set value for loggedOut to avoid the page rendering before redirect to login page
        if (sessionStorage.getItem('isLoggedOut') == null) {
            sessionStorage.setItem('isLoggedOut', "true");
        }
    }

    showApp(token, accountId, tokenExpiration, isAuthorized, portalId) {
        this.setState({
            token : token,
            accountId: accountId,
            tokenExpiration: tokenExpiration,
            authorized: isAuthorized,
            portalId: portalId
        })
    };

    setUnauthorized() {
        this.setState({
            authorized : false
        })
    };

    setAdmin(isAdmin) {
        this.setState({
            isAdmin : isAdmin
        })
    }

    setBusinessName(businessName){
        this.setState({
            businessName : businessName
        })
    }

    setVradiusServerId(vRadiusServerId){
        this.setState({
            vRadiusServerId : vRadiusServerId
        })
    }

    render() {
        return (
            <div>
                <header>
                    <div id="gradient"></div>
                    {(this.state.businessName ===null || this.state.businessName==='' || this.state.businessName === undefined)?
                    <a href="/">proximus</a>:
                    <h2 className="purple" style={{marginLeft: '45px'}}>{this.state.businessName}</h2>}
                </header>
                <Switch>
                    <Route exact path="/login" component={CustomerLogin}/>
                    <Route exact path="/" render={(props) => (<App accessToken={this.state.token}
                                                                   accountId={this.state.accountId}
                                                                   tokenExpiration={this.state.tokenExpiration}
                                                                   setUnauthorized={this.setUnauthorized}
                                                                   authorized={this.state.authorized}
                                                                   isAdmin={this.state.isAdmin}
                                                                   setBusinessName={this.setBusinessName}
                                                                   portalId={this.state.portalId}
                                                                   vRadiusServerId={this.state.vRadiusServerId}
                                                                   {...props}/>)} />
                    <Route exact path="/adminlogin" render={(props) => (<Login showApp={this.showApp}
                                                                               setAdmin={this.setAdmin}
                                                                               setBusinessName={this.setBusinessName}
                                                                               setVradiusServerId={this.setVradiusServerId}
                                                                               {...props}/>)}/>
                    <Route exact path="/callback" render={(props) => (<SSORedirectURL showApp={this.showApp}
                                                                                      setAdmin={this.setAdmin}
                                                                                      setBusinessName={this.setBusinessName}
                                                                                      setVradiusServerId={this.setVradiusServerId}
                                                                                      {...props}/>)}/>
                    <Redirect from='*' to='/login' />
                </Switch>
            </div>
        );
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.jsx